import {connect} from "redux-vue";
import PageTemplate from "./PageTemplate";
import * as modulesActions from "../actions/modules";
import * as moduleActions from "../actions/module";
import * as userActions from "../actions/user";
import {filterFn} from "../helpers/tools";
import ModuleItem from "../components/ModuleItem";
import ModuleCard from "../components/ModuleCard";
import ProgressBar from "../components/ProgressBar";
import circlewithstar from "../assets/circlewithstar.svg";
import circlewithcup from "../assets/circlewithcup.svg";
import ApiError from "../components/ApiError";
import LoadingIndicator from "../components/LoadingIndicator";
import {getScreenSize} from "../helpers/screens";
import classNames from "classnames";

const CoursesPage = {
  props: [
    'user', 'fetchModules', 'modules', 'setModule', 'enrollModule', 'module',
    'unEnrollModule', 'setEnrollMaster', 'masterCertificatePDF'
  ],

  data () {
    return {
      filter: "",
      masterEnroll: false,
      masterEnrollModels: [],
      masterEnrollErrors: [],
      masterUnEnrollErrors: [],
    }
  },

  mounted () {
    if (this.$route.query.enrollMaster) {
      this.onPressMasterEnroll();
    }
  },

  watch: {
    module (nextVal, val) {
      if (this.masterEnroll) return;

      if (
        (nextVal.enrollError !== val.enrollError && nextVal.enrollError) ||
        (nextVal.unEnrollError !== val.unEnrollError && nextVal.unEnrollError)
      ) {
        const error = nextVal.enrollError || nextVal.unEnrollError;
        if (error.response && error.response.data && error.response.data.message) {
          Snackbar.show({
            showAction: false,
            text: error.response.data.message,
            customClass: "text-red-500",
            duration: 5000,
            actionText: this.$t('dismiss'),
          });
        }
      }

      if (!val.enrollSuccess && nextVal.enrollSuccess) {
        Snackbar.show({
          text: this.$t('courses_page.enroll_success_message', {
            course_sequence_name: this.$t('courses_page.course_sequence_name', {
              sequence: this.module.model.sequence,
              name: this.module.model.name
            })
          }),
          actionText: this.$t('undo'),
          onActionClick: (element) => {
            element.style.opacity = 0;
            this.onPressUnEnroll();
          },
          duration: 5000
        });
      }
    }
  },

  methods: {


    /**
     *
     * @param row
     * @returns {function(): (Function|*)}
     */
    onPressTranscript () {
      return (e) => {
        e.preventDefault();
        this.$router.push({name: 'TranscriptModal'});
      }
    },

    /**
     *
     * @returns {Promise<void>}
     */
    async onPressMasterEnroll () {
      const isAuthorized = !!(this.user.token && this.user.model);

      if (!isAuthorized) {
        this.setEnrollMaster();
        this.$router.push({name: 'RegisterModal'});
        return;
      }

      const unEnrolledCollection = this.modules.collection.filter(i => !i.enrolled && i.sequence < 16);

      if (unEnrolledCollection.length) {
        this.masterEnroll = true;

        for (const module of unEnrolledCollection) {
          const hasActivity = (module.lessons || [])
            .some(lesson => !!lesson.activities.length);
          if (hasActivity) {
            await this.enrollModule(module);
            if (this.module.enrollSuccess) {
              this.masterEnrollModels.push(module);
            }
            if (this.module.enrollError) {
              this.masterEnrollErrors.push(module);
            }
          }
        }

        if (this.masterEnrollErrors.length > 0) {
          Snackbar.show({
            text: this.$t('courses_page.master_enroll_error_message'),
            customClass: "text-red-500",
            actionText: this.$t('retry'),
            onActionClick: (element) => {
              element.style.opacity = 0;
              this.masterEnrollErrors = [];
              this.onPressMasterEnroll();
            },
            duration: 0,
          })
        } else {
          Snackbar.show({
            text: this.$t('courses_page.master_enroll_success_message'),
            actionText: this.$t('undo'),
            onActionClick: (element) => {
              element.style.opacity = 0;
              this.onPressMasterUnEnroll();
            },
            duration: 5000,
          });
        }

        this.masterEnroll = false;
      }
    },

    /**
     *
     * @returns {Promise<void>}
     */
    async onPressMasterUnEnroll () {
      this.masterEnroll = true;

      for (const module of this.masterEnrollModels) {
        await this.unEnrollModule(module);
        if (this.module.unEnrollError) {
          this.masterUnEnrollErrors.push(module);
        }
      }

      if (this.masterUnEnrollErrors.length > 0) {
        Snackbar.show({
          text: this.$t('courses_page.master_un_enroll_error_message'),
          customClass: "text-red-500",
          actionText: this.$t('retry'),
          onActionClick: (element) => {
            element.style.opacity = 0;
            this.masterUnEnrollErrors = [];
            this.onPressMasterUnEnroll();
          },
          duration: 0
        })
      } else {
        this.masterEnrollModels = [];
      }

      this.masterEnroll = false;
    },

    /**
     *
     */
    onPressUnEnroll () {
      this.unEnrollModule(this.module.model);
    },

    /**
     *
     */
    onPressDownloadMasterCert () {
      this.masterCertificatePDF();
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const isAuthorized = !!(this.user.token && this.user.model);

    const unEnrolledCollection = this.modules.collection.filter(i => !i.enrolled);
    const enrolledCollection = this.modules.collection.filter(i => i.enrolled && !i.completed);
    const enrolledAllMaster = this.modules.collection.filter(i => i.enrolled && i.sequence < 16).length === 15;
    const completedCollection = this.modules.collection.filter(i => i.enrolled && i.completed);
    const completedMasterCollection = this.modules.collection.filter(i => i.enrolled && i.completed && i.sequence < 16);
    const totalCount = 15;//this.modules.collection.filter(i => i.sequence < 16).length;
    const percentComplete = Math.round((completedMasterCollection.length / totalCount) * 100);
    const completedMaster = percentComplete === 100;

    let headerGraphic = null;
    let h1Text = this.$t('courses_page.improve_your_performance');
    let h2Text = this.$t('courses_page.enroll_in_courses');
    if (isAuthorized) {
      if (percentComplete === 0) {
        headerGraphic = <img src={circlewithstar} alt="" class="mx-auto h-40 mb-3"/>;
        h1Text = unEnrolledCollection.length > 0 ? this.$t('courses_page.great_start') : this.$t('courses_page.you_are_enrolled');
        h2Text = this.$t('courses_page.see_your_courses_below');
      }

      if (percentComplete > 0 && percentComplete < 100) {
        headerGraphic = <ProgressBar value={percentComplete} class="mb-3"/>;
        h1Text = this.$t('courses_page.you_have_completed_n_courses', {
          courses: this.$tc('courses_page.n_courses', completedCollection.length)
        });
        h2Text = this.$t('courses_page.complete_the_remaining_n_courses', {
          courses: this.$tc('courses_page.n_courses', totalCount - completedMasterCollection.length)
        });
      }

      if (percentComplete === 100) {
        headerGraphic = <img src={circlewithcup} alt="" class="mx-auto h-40 mb-3"/>;
        h1Text = this.$t('courses_page.you_have_completed_all_courses');
        h2Text = this.$t('courses_page.you_can_retake_courses_anytime');
      }
    }

    const header = (
      <div class="bg-secondary">
        <div class="container lg:w-2/5 mx-auto px-3 lg:px-6 py-12 z-10 relative text-center">
          {headerGraphic}
          <h2 class="text-2xl lg:text-3xl font-bold text-white">
            {h1Text}
          </h2>
          <h6 class="text-white">
            {h2Text}
          </h6>
          {completedMaster && (
            <button
              class="mt-4 px-2 lg:px-5 p-1 lg:p-2 rounded-full bg-primary focus:outline-none text-xs lg:text-base text-white"
              type="button" onClick={this.onPressDownloadMasterCert} disabled={this.modules.createMasterPdf}>
              {this.modules.createMasterPdf
                ? <LoadingIndicator/>
                : (
                  <fragment>
                    <i class="mdi mdi-seal mr-2"></i>
                    {this.$t('courses_page.download_master_cert')}
                  </fragment>
                )
              }
            </button>
          )}
        </div>
      </div>
    );

    const mlmCoursesLoadingIndicator = this.modules.fetch && (
      <div class="container mx-auto overflow-x-hidden">
        <div class="flex flex-wrap items-center bg-gray-300 -mx-3">
          {Array(getScreenSize() === 'sm' ? 4 : 8).fill().map(i => (
            <div class="w-full lg:w-1/4 p-3">
              <div class="bg-white shadow card-loading rounded"></div>
            </div>
          ))}
        </div>
      </div>
    );

    const filterRegEx = new RegExp(this.filter, "gi");

    const replaceFn = string => {
      return `<span class="bg-yellow-400">${string}</span>`
    };

    const filteredCollection = unEnrolledCollection.filter(filterFn(this.filter));
    const showFilteredCollection = (filteredCollection.length > 0 || this.filter.length > 0 || this.modules.fetch);
    const filteredModulesList = (
      <div class="bg-gray-300">
        <div class={classNames("container mx-auto px-3 lg:px-6 z-10 relative", {'pt-10 pb-10' : showFilteredCollection})}>
          {showFilteredCollection && (
            <div class="flex flex-col lg:flex-row lg:items-center mb-6">
              <h3 class="text-xl lg:text-2xl font-bold mb-2 lg:mb-0">
                {this.filter.length > 0 ? this.$t('courses_page.search_results') : this.$t('courses_page.all_mlm_courses')}
              </h3>
              <div class="w-full lg:w-4/12 ml-auto">
                <div class="relative">
                  <input type="search" v-model={this.filter} disabled={this.modules.fetch}
                         class="shadow rounded border-0 p-2 lg:p-3 w-full focus:outline-none focus:shadow-outline bg-white"
                         placeholder={this.$t('courses_page.what_do_you_want_to_learn_about')}/>
                  {this.filter.length > 0 || (
                    <div class="absolute top-0 right-0 mt-3 mr-4">
                      <i class="mdi mdi-magnify"></i>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {mlmCoursesLoadingIndicator}
          {this.modules.fetch || (
            <div class="flex flex-wrap -mx-3">
              {filteredCollection.map(i => (
                <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-3">
                  
                <ModuleCard key={i.id + this.filter} modelProp={i} highlight={this.filter}/>
		</div>
              ))}

              {(filteredCollection.length > 0 && this.filter.length === 0 && !enrolledAllMaster) && (
                <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-3">
                  <div class="bg-secondary shadow rounded overflow-hidden h-full">
                    <div class="flex flex-col h-full">
                      <div class="p-3 text-white flex-1">
                        <i class="mdi mdi-school text-green-400 text-5xl leading-none"></i>
                        <h3 class="font-bold text-xl mb-5">
                          {this.$t('courses_page.mlm_master_cert')}
                        </h3>
                        <p>
                          {this.$t('courses_page.enroll_master')}
                        </p>
                      </div>
                      <div class="bg-accent">
                        <div class="flex items-center justify-between p-3">
                          <div>&nbsp;</div>
                          <button
                            class="px-3 p-2 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline"
                            type="button" onClick={this.onPressMasterEnroll} disabled={this.masterEnroll}>
                            {this.masterEnroll && <LoadingIndicator/>}
                            {this.masterEnroll || (
                              <fragment>
                                <i class="mdi mdi-plus mr-2"></i>
                                {this.$t('courses_page.enroll')}
                              </fragment>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {filteredCollection.length === 0 && this.filter.length > 0 && (
                <div class="w-full lg:w-5/12 p-3 ml-auto">
                  <div class="bg-red-500 text-white rounded p-5 text-base italic mb-6" role="alert">
                    {this.$t('courses_page.search_error_message')}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
    const pageContent = (
      <fragment>
          {!this.modules.fetch && (enrolledCollection.length > 0 || completedCollection.length > 0) && (
          <div class="bg-gray-300">
            <div class="container mx-auto pb-10 px-3 lg:px-6 pt-5 lg:pt-10 z-10 relative">
              <div class="flex justify-between items-start flex-grow-0">
              <h3 class="text-xl lg:text-2xl font-bold mb-4">
                {this.$t('courses_page.my_courses')}
              </h3>
              {completedCollection.length > 0 &&
              <button class="p-2 px-4 rounded-full text-white bg-secondary focus:shadow-outline text-sm flex-grow-0" onClick={this.onPressTranscript()}>
                    <i class="mdi mdi-download mr-5"></i>
                    {this.$t('courses_page.view_my_results')}
              </button>
              }
              </div>
              {enrolledCollection.length > 0 &&
              <ul class="bg-white lg:pb-3">
                <li class="flex border-b-2 py-2 px-3 lg:px-5">
                  <p class="font-bold text-sm w-6/12">
                    {this.$t('courses_page.enrolled_courses')}
                  </p>
                  <p class="font-bold text-sm w-6/12 hidden lg:block">
                    {this.$t('courses_page.progress')}
                  </p>
                </li>
                {enrolledCollection.map(i => <ModuleItem modelProp={i} key={i.id}/>)}
              </ul>
            

              }
              </div>
          </div>
        )}

        {!this.modules.fetch && completedCollection.length > 0 && (
          <div class="bg-gray-300">
            <div class="container mx-auto px-3 lg:px-6 pt-5 lg:pt-10 lg:pb-10 z-10 relative">
              <ul class="bg-white lg:pb-3">
                <li class="border-b-2 py-2 px-5">
                  <p class="font-bold text-sm lg:w-1/2">
                    {this.$t('courses_page.completed_courses')}
                  </p>
                </li>
                {completedCollection.map(i => <ModuleItem modelProp={i} key={i.id}/>)}
              </ul>
            </div>
          </div>
        )}

        {filteredModulesList}
      </fragment>
    );

    const apiError = this.modules.fetchError && (
      <ApiError error={this.modules.fetchError} class="mb-0"/>
    );

    return (
      <PageTemplate>
       
        {header}
        
        {pageContent}
        {apiError}
      </PageTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    modules: state.modules,
    module: state.module,
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchModules: () => dispatch(modulesActions.fetchModules()),
    setModule: module => dispatch(moduleActions.setModule(module)),
    enrollModule: async module => await dispatch(moduleActions.enrollModule(module)),
    unEnrollModule: async module => await dispatch(moduleActions.unEnrollModule(module)),
    setEnrollMaster: () => dispatch(userActions.setEnrollMaster()),
    masterCertificatePDF: () => dispatch(modulesActions.masterCertificatePDF()),
  }
}

export default connect(mapStateToProps, mapActionToProps)(CoursesPage);